export class Region {
  id:number;
  name:string;
  kind:string;
  wkt :string;
  schemaLink:string;
  area: string;
  numberofUsers:number;
  cacheStaus:string;
}
